import { List } from "@material-ui/core";
import React from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./footer.css";

const Footer = () => {
  return (
    <React.Fragment>
      <div className="navbar">
        <a href={List}>
          <img
            className="footer-img"
            src={require("../../images/6movies-item.png")}
            alt=""
          ></img>
        </a>
      </div>
      <div className="navbar justify-content-center">
        <span className="footer-bottom">
          © Developed by
          <a
            href="https://randyaajr.github.io/portfolio-randy/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "red" }}
          >
            {" "}
            Randy Anderson
          </a>
        </span>
      </div>
    </React.Fragment>
  );
};
export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js